import styled from "styled-components";

const Container = styled.div`
  max-width: 767px;
  width: 100%;
  min-height: 260px;
`;

const Body = styled.div`
  padding: 15px 0 10px;
`;
const ActionBtn = styled.div`
  display: flex;

  padding: 20px 0;
  margin-top: 20px;
  > button {
    height: 40px;
    width: 140px;
    /* margin-left: 15px; */
  }
`;
const Location = styled.div`
  .for-mileage-dropdown-height {
    .react-select__menu-list {
      max-height: 112px;
    }
  }
  .react-select__menu {
    top: -4px;
  }
  .min-height {
    min-height: 84px;
    @media (max-width:903px) {
   .react-select__input{
     display: none;
    }
  }
  }
  .react-select__option {
    font-size: 14px;
  }
  h6,
  p {
    text-align: left;
  }
  h3 {
    color: #000000;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
`;
const Categories = styled.div`
  h6 {
    text-align: left;
  }
  .xIcon {
    position: absolute;
    right: -24px;
    top: 11px;
    width: 18px;
    opacity: 0.5;
  }
  @media (max-width: 767px) {
    .blank-space {
      display: none;
    }
  }
`;
export { Container, Body, ActionBtn, Location, Categories };
